import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { useState } from 'react';


export const useCleanRoomSummaryHeaders = (crId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const [data, setData] = useState({
    partners: 0,
    datasets: 0,
  });

  const {
    isLoading, isError, isSuccess, isFetching,
  } = useQuery(
    ['CleanRoomSummaryHeaders', { orgId, crId }],
    () => axiosInstance.get(cleanRoom(orgId).cleanRoomSummaryHeaders(crId)),
    {
      onSuccess: (res) => res.data && setData(res.data),
      onError: (err) => {
        const errorMessage = err?.response?.data?.message || 'Failed to fetch run summary headers';
        dispatch(showAlert({ message: errorMessage, type: 'error' }));
      },
    });

  return {
    isLoading,
    isError,
    isSuccess,
    data,
    isFetching,
  };
};
